module.exports = __webpack_public_path__ + "static/media/portfolio-1.502b25ba.jpg";